__turbopack_context__.v({
  "control": "IkjriG_control",
  "controls": "IkjriG_controls",
  "form": "IkjriG_form",
  "heading": "IkjriG_heading",
  "lead": "IkjriG_lead",
  "privacy": "IkjriG_privacy",
  "wrapper": "IkjriG_wrapper",
});
